import { jsx } from 'react/jsx-runtime';

var n=({children:o,size:t,...e})=>jsx("svg",{...e,fill:"none",height:t,width:t,children:o});var c=o=>jsx(n,{...o,viewBox:"0 0 32 32",children:jsx("path",{d:"M12 23.9364L19.9352 16.0318L12.1296 8",stroke:"currentcolor",strokeLinecap:"round",strokeLinejoin:"round"})}),d=c;

export { d as default };
